module.exports = __webpack_public_path__ + "static/media/register3.d9309efc.png";